const RedeemLimitType = {
  Station: "station",
  Universal: "universal",
};

export default RedeemLimitType;
